var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideIn"}},[_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"quiz-flow__header whiteSpacePreWrap",domProps:{"innerHTML":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }